import { Flame } from "lucide-react";

export default function Sticker({ size = 160, className = "" }) {
  const r = size / 2;
  const trackRadius = r - 14;
  // Circumference of the text track
  const circumference = 2 * Math.PI * trackRadius;
  // Single string that fills the ring — bullet separators space it evenly
  const label = "HOT SAUCE MEDIA \u2003\u2022\u2003HOT SAUCE MEDIA \u2003\u2022\u2003";

  return (
    <div
      className={`relative spin-slow ${className}`}
      style={{ width: size, height: size }}
      aria-hidden
    >
      <svg viewBox={`0 0 ${size} ${size}`} width={size} height={size}>
        <defs>
          <path
            id="stickerRing"
            d={`
              M ${r},${r}
              m -${trackRadius},0
              a ${trackRadius},${trackRadius} 0 1,1 ${trackRadius * 2},0
              a ${trackRadius},${trackRadius} 0 1,1 -${trackRadius * 2},0
            `}
          />
        </defs>

        {/* Red ring */}
        <circle cx={r} cy={r} r={r - 2} fill="#FF1111" />
        {/* White inner circle */}
        <circle cx={r} cy={r} r={r - 20} fill="#ffffff" />

        {/* Circular text — textLength forces it to fill exactly one lap */}
        <text
          fill="#09090B"
          style={{
            fontFamily: "JetBrains Mono, monospace",
            fontSize: 11,
            fontWeight: 700,
            textTransform: "uppercase",
          }}
        >
          <textPath
            href="#stickerRing"
            startOffset="0"
            textLength={circumference}
            lengthAdjust="spacing"
          >
            {label}
          </textPath>
        </text>
      </svg>

      {/* Flame icon centred */}
      <div className="absolute inset-0 flex items-center justify-center">
        <Flame
          size={Math.round(size * 0.28)}
          strokeWidth={2.2}
          className="text-[#FF1111]"
        />
      </div>
    </div>
  );
}
